import { createReducer, MetaReducer, on } from '@ngrx/store';
import { IErrorLog } from '../../../../model/error-logs';
import ErrorLogsActions from './error-logs.action-types';
export const errorLogsFeatureKey = 'errorLogs';

export interface ErrorLogsState {
    errorLogs: IErrorLog[];
}

export const initialErrorLogsState: ErrorLogsState = {
    errorLogs: []
};

export const metaReducers: MetaReducer<ErrorLogsState>[] = [];

export const errorLogsContextReducer = createReducer(
    initialErrorLogsState,

    // Links
    on(ErrorLogsActions.loadErrorLogs, (state, action) => {
        return {
            errorLogs: action.errorLogs
        };
    })
);
